import { Button } from '@/components/ui/Button'
import { Icon } from '@/components/ui/Icon'
import { Modal } from '@/components/ui/Modal'
import { RouteDateSelect } from '@/pages/Settings/RouteDateSelect'
import { ThemeSelect } from '@/pages/Settings/ThemeSelect'
import { VehicleSelect } from '@/pages/Settings/VehicleSelect'
import { useAuthStore } from '@/store/auth'
import { useRouteStore } from '@/store/route'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './Settings.module.scss'

export const SettingsPage = () => {
  const navigate = useNavigate()
  const clearAuth = useAuthStore((state) => state.clearAuth)
  const clearRoute = useRouteStore((state) => state.clearRoute)
  const [logoutModalOpen, setLogoutModalOpen] = useState(false)

  const handleLogout = () => {
    clearAuth()
    clearRoute()
    navigate('/login', { replace: true })
  }

  return (
    <div className={styles.container} data-testid="settings-page">
      <div className={styles.content}>
        <header className={styles.header}>
          <h1 className={styles.title}>Menu</h1>
          <Button
            icon={<Icon name="x" size={20} className={styles.closeIcon} />}
            onClick={() => navigate('/')}
            className={styles.closeButton}
            testId="settings-close-button"
          />
        </header>

        <section
          className={styles.section}
          data-testid="settings-truck-section"
        >
          <h2 className={styles.sectionTitle}>Selected Truck & Day</h2>
          <div className={styles.selects}>
            <VehicleSelect />
            <RouteDateSelect />
          </div>
        </section>

        <div className={styles.divider} />

        <section className={styles.section} data-testid="settings-app-section">
          <h2 className={styles.sectionTitle}>App Settings</h2>
          <div className={styles.themeSelect}>
            <ThemeSelect />
          </div>
          <div className={styles.settingsList}>
            <button
              className={styles.settingsLink}
              onClick={() => navigate('/change-password')}
              data-testid="settings-change-password"
            >
              <Icon name="password" size={24} />
              <span className={styles.settingsLinkText}>Change Password</span>
              <Icon name="arrow" size={16} />
            </button>

            <button
              className={styles.settingsLink}
              onClick={() => navigate('/profile-settings')}
              data-testid="settings-profile"
            >
              <Icon name="user" size={24} />
              <span className={styles.settingsLinkText}>Profile Settings</span>
              <Icon name="arrow" size={16} />
            </button>

            <a
              className={styles.settingsLink}
              href="https://resupplyapp.com/"
              data-testid="settings-resource-center"
            >
              <Icon name="resource" size={24} />
              <span className={styles.settingsLinkText}>Resource Center</span>
              <Icon name="arrow" size={16} />
            </a>
          </div>
        </section>

        <footer className={styles.footer}>
          <Button
            text="Log Out"
            variant="default"
            icon={<Icon name="logout" size={14} />}
            iconPosition="left"
            onClick={() => setLogoutModalOpen(true)}
            className={styles.logoutButton}
            testId="settings-logout-button"
          />
        </footer>
      </div>

      <Modal
        isOpen={logoutModalOpen}
        onClose={() => setLogoutModalOpen(false)}
        title="Log Out?"
        testId="logout-modal"
        buttons={[
          <Button
            text="Go Back"
            variant="default"
            onClick={() => setLogoutModalOpen(false)}
            className={styles.logoutModalButton}
            testId="logout-modal-back"
          />,
          <Button
            text="Log Out"
            variant="error"
            onClick={handleLogout}
            className={styles.logoutModalButton}
            testId="logout-modal-confirm"
          />,
        ]}
      >
        <div className={styles.logoutModalContent}>
          <p className={styles.logoutModalText}>
            Are you sure you want to log out?
          </p>
        </div>
      </Modal>
    </div>
  )
}
